import React from 'react';
const bonuses = [{
  title: 'Elite Skill Blueprints™',
  description: 'Complete development systems for Muscle-Up, Handstand, Front Lever, Back Lever, Planche, Human Flag, and L-Sit, including assessments, progressions, strength work, mobility, corrections, and ready-to-use sessions.'
}, {
  title: 'Calisthenics Strength & Mobility Lab™',
  description: 'Professional strength and mobility protocols for wrists, shoulders, scapulae, spine, hips, and core, including activation, stability, recovery, injury-prevention, and movement-preparation routines.'
}, {
  title: 'Group Class System™',
  description: 'Ready-to-use group sessions featuring circuits, stations, partner workouts, skill classes, strength sessions, mixed-level adaptations, EMOMs, AMRAPs, and complete class structures.'
}, {
  title: 'Athlete Testing & Performance System™',
  description: 'Professional testing protocols, strength benchmarks, skill evaluations, assessment sheets, progress reports, and tracking resources to measure athlete development objectively.'
}, {
  title: '52 High-Performance Calisthenics Sessions™',
  description: 'A complete year of structured sessions featuring warm-ups, skill blocks, strength training, accessory work, conditioning, mobility, coaching instructions, and level-based adaptations.'
}];
const benefits = [{
  emoji: '⚡',
  title: 'Save Hours Every Week',
  description: 'Stop creating workouts, progressions, and training plans from scratch. Simply open the system, select the resources you need, and begin every session fully prepared.'
}, {
  emoji: '👑',
  title: 'Coach With Greater Confidence',
  description: 'Lead every session with professional structure, clear progressions, organized programming, and ready-to-use coaching tools that eliminate uncertainty.'
}, {
  emoji: '💪',
  title: 'Help Your Athletes Progress Faster',
  description: 'Improve strength, body control, technique, mobility, and skill development through structured systems that keep every athlete moving toward measurable goals.'
}, {
  emoji: '😊',
  title: 'Deliver More Professional Coaching Sessions',
  description: 'Use complete plans, assessment tools, progress trackers, coaching documents, and organized resources to provide a higher-level experience to every athlete.'
}];
export function BonusSection() {
  return <>
      <section className="bg-brand-coal px-4 py-5 text-white sm:px-6" aria-labelledby="bonus-heading" data-id="element-15" data-mp="1m3jl9lwukfz1">
        <div className="mb-4 text-center" data-id="element-16" data-mp="ydp7n24pendq">
          <h2 id="bonus-heading" className="mb-1 text-3xl leading-none text-white sm:text-5xl" data-id="element-17" data-mp="yajglhcilbfd">5 PREMIUM BONUSES INCLUDED</h2>
          <p className="text-xs font-medium leading-snug text-brand-mist sm:text-sm" data-id="element-18" data-mp="175r64uv7ptld">You&apos;ll also receive 5 premium bonuses designed to help you save even more planning time, improve athlete development, and deliver a more professional coaching experience.</p>
        </div>
        <div className="space-y-2" data-id="element-19" data-mp="anbcv3uqiafg">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="border-2 border-brand-lime bg-white p-3 text-center text-brand-coal shadow-[3px_3px_0_#84CC16]" data-id="element-20" data-mp="al8qctssizfh" data-mpi={index}>
              <p className="mb-1 text-[10px] font-extrabold tracking-wide text-brand-steel" data-id="element-21" data-mp="5acyr0r3qxxo">🎁 BONUS {index + 1} — {bonus.title}</p>
              <p className="text-[11px] leading-snug text-brand-steel sm:text-xs" data-id="element-22" data-mp="3ms60kk3hdznh">{bonus.description}</p>
            </article>)}
        </div>
      </section>
      <section className="border-t-4 border-brand-lime bg-white px-4 py-5 sm:px-6" aria-labelledby="change-heading" data-id="element-23" data-mp="j9mey0fb5s1n">
        <h2 id="change-heading" className="mb-4 text-center text-3xl leading-none text-brand-coal sm:text-5xl" data-id="element-24" data-mp="o7nyemgnbtdn">WHAT WILL CHANGE</h2>
        <div className="space-y-2" data-id="element-25" data-mp="9dssnpbsek6o">
          {benefits.map(benefit => <article key={benefit.title} className="flex gap-2.5 border-l-4 border-brand-lime bg-brand-mist p-2.5 shadow-[2px_2px_0_#111111]" data-id="element-26" data-mp="e984kbq8i60g">
              <span className="text-lg" aria-hidden="true" data-id="element-27" data-mp="2z10gfsqicl7d">{benefit.emoji}</span>
              <div data-id="element-28" data-mp="2yynruwq8vclc">
                <h3 className="mb-0.5 text-lg leading-none text-brand-coal sm:text-xl" data-id="element-29" data-mp="3f7wovdskbabq">{benefit.title}</h3>
                <p className="text-[11px] leading-snug text-brand-steel sm:text-xs" data-id="element-30" data-mp="3agwry8jg0s98">{benefit.description}</p>
              </div>
            </article>)}
        </div>
      </section>
    </>;
}